(function () {
    "use strict";

    angular.module("fancy.schema-form-builder-studio")
        .controller("HomeController", ["$http", function ($http) {
            
            var vm = this; 
            
        }]);

})();